export const isPhoneValid = (phone: string) => !!phone && !!/\+\d+/.exec(phone);
